import type { PlayerProfileResponse, PlayerRatingAllResponse } from '@on3/api';
import { ServiceLogo } from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import { StarRatings } from 'src/components/UI/StarRatings';

import styles from './ConsensusModule.module.scss';

interface IConsensusProps {
  basicInfo?: PlayerProfileResponse;
  consensus?: PlayerRatingAllResponse;
}

export const ConsensusModule = ({ basicInfo, consensus }: IConsensusProps) => {
  const {
    overallRank,
    positionAbbr,
    positionRank,
    rating,
    rankingYear,
    stars,
    stateAbbr,
    stateRank,
  } = consensus || {};

  const baseRankingLink = `/rivals/rankings/consensus-player/${basicInfo?.defaultSport?.name?.toLowerCase()}/${basicInfo?.classYear}/`;
  const isRivalsRating = !!rankingYear && rankingYear > 2025;

  return (
    <div className={styles.consensusWrapper}>
      <div className={styles.header}>
        <h1>Industry Comparison</h1>
      </div>
      <div className={styles.rankingWrapper}>
        <div className={styles.ratings}>
          <ServiceLogo
            className={styles.industryLogo}
            type={isRivalsRating ? 'industry' : 'on3industry'}
          />
          <span className={styles.rating}>{rating?.toFixed(2)}</span>
          <span className={styles.stars}>
            <StarRatings stars={stars} />
          </span>
        </div>
        <div className={styles.playerRanks}>
          <div className={styles.group}>
            <span aria-label="National" className={styles.label}>
              Natl
            </span>
            <a
              className={styles.rankingNumber}
              href={baseRankingLink}
              rel="noopener noreferrer"
              target="_blank"
            >
              {overallRank || '-'}
            </a>
          </div>
          <div className={styles.group}>
            <span className={styles.label}>{`Pos - ${positionAbbr}`}</span>
            <a
              className={styles.rankingNumber}
              href={`${baseRankingLink}?position=${positionAbbr?.toLowerCase()}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {positionRank || '-'}
            </a>
          </div>
          <div className={styles.group}>
            <span className={styles.label}>{`State - ${stateAbbr}`}</span>
            <a
              className={styles.rankingNumber}
              href={`${baseRankingLink}?state=${stateAbbr?.toLowerCase()}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {stateRank || '-'}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
